import Key from "csi/core/Key";
import Widget from "csi/table/Widget";
import { C8AttributeKey } from "csi/typings";
import declare from "dojo/_base/declare";
import Sourcing from "../../Sourcing/main.js";

const GroupBySourceTable = declare(Widget, {
	/**
	 * @override
	 * Don't render SupplierFactory heading on Supplier SR subtypes
	 */
	onViewResolveKeysToSkip(skipSet: Set<C8AttributeKey>): void {
		const viewNode = this.getViewNode();
		if (viewNode && Sourcing.isSubtypeSupplierSourced(viewNode.SRSubtype)) {
			skipSet.add(Key.untypedKeyFromParts({ id: "SupplierFactory", path:"Child:__Parent__" }));
		}
	},

	/**
	 * @override
	 * Default Table View to Group by Supplier if it exists on the __Parent__
	 */
	onCreateDefaultCustomView(cv) {
		this.inherited(arguments);
		const subtypeURL = this.getViewNode().SRSubtype;
		const productSourceCreationLevel = Sourcing.isSubtypeSupplierSourced(subtypeURL) ? "Supplier" : "SupplierFactory";
		this.setDefaultGroupAndExpand(productSourceCreationLevel, "Child:__Parent__");
	},
});

export = GroupBySourceTable;